<script lang="ts">
	import { combinePageArrays, getPaginatedDocument } from '$lib/helpers/app.documents';
	import { filter, type Content, type Ordering } from '@prismicio/client';
	import type { SliceComponentProps } from '@prismicio/svelte';
	import { inview } from 'svelte-inview';
	import { fade } from 'svelte/transition';
	import type { NewsDocument } from '../../../prismicio-types';
	import NewsCard from '$lib/components/NewsCard.svelte';

	type Props = SliceComponentProps<Content.NewsListSlice>;

	const { slice }: Props = $props();
	const columns = 12 / (slice.primary.columns ?? 3);
	const hdColumns = 12 / ((slice.primary.columns ?? 3) + 1);
	const perPage: number = slice.primary.per_page ?? 1;

	let loading: boolean = $state(false);
	let nextPage: boolean = $state(true);
	let articles: NewsDocument[] = $state([]);
	let pageNumber: number = $state(1);
	let currentFilter: string = $state('');
	let filters: string[] = $state([]);
	let ordering: Ordering[] = [
		{
			field: 'my.news.publish_date',
			direction: 'desc'
		}
	];

	const handleFilter = async (e: MouseEvent) => {
		e.preventDefault();
		const button = e.currentTarget as HTMLButtonElement;
		if (button) {
			const value = button.dataset.value as string;
			if (value !== '') {
				currentFilter = value;
				filters = [filter.at('document.tags', value)];
			} else {
				currentFilter = '';
				filters = [];
			}

			pageNumber = 1;
			nextPage = true;
			await loadArticles(false);
		}
	};

	const loadArticles = async (useCombine: boolean) => {
		if (loading) return;

		loading = true;
		await getPaginatedDocument('news', perPage, pageNumber, nextPage, filters, ordering)
			.then((response) => {
				console.log(response);
				if (!response) {
					throw new Error('Error retrieving documents');
				}

				const results = response.results as NewsDocument[];
				if (articles && useCombine) {
					articles = combinePageArrays(articles, results);
				} else {
					articles;
					articles = results;
				}

				pageNumber = response.pageNum + 1;
				nextPage = response.nextPage;
			})
			.catch((error) => console.error(error))
			.finally(() => (loading = false));
	};
</script>

<section
	class="team-list spacing-top-{slice.primary.spacing_top} spacing-bottom-{slice.primary
		.spacing_bottom}"
	data-slice-type={slice.slice_type}
	data-slice-variation={slice.variation}
>
	{#if slice.primary.show_filters == true}
		<div class="container-lg px-0 p-lg-3">
			<ul class="team-list__filters spacing-bottom-{slice.primary.spacing_top}">
				<li>
					<button
						class="btn btn-secondary"
						class:active={filters.length < 1}
						onclick={handleFilter}
						data-value="">All</button
					>
				</li>
				<li>
					<button
						class="btn btn-secondary"
						class:active={currentFilter == 'Forward'}
						onclick={handleFilter}
						data-value="Forward">Forward</button
					>
				</li>
				<li>
					<button
						class="btn btn-secondary"
						class:active={currentFilter == 'Defence'}
						onclick={handleFilter}
						data-value="Defence">Defence</button
					>
				</li>
				<li>
					<button
						class="btn btn-secondary"
						class:active={currentFilter == 'Netminder'}
						onclick={handleFilter}
						data-value="Netminder">Netminder</button
					>
				</li>
			</ul>
		</div>
	{/if}

	<div class="container">
		<div class="row align-items-stretch gy-5">
			{#if articles.length}
				{#each articles as article}
					<div class="col-12 col-lg-{columns} col-hd-{hdColumns}" transition:fade>
						<NewsCard {article} />
					</div>
				{/each}
			{/if}
		</div>

		{#if nextPage}
			<div class="d-flex justify-content-center mt-5">
				<button
					class="btn btn-lg btn-text"
					onclick={() => loadArticles(true)}
					use:inview
					oninview_enter={() => loadArticles(true)}
				>
					{#if loading}
						<span>Loading...</span>
					{:else}
						<span transition:fade>Load more</span>
					{/if}
				</button>
			</div>
		{/if}
	</div>
</section>
